<h3 class="title">Validation Errors</h3>
<p>Fix the following errors and then try saving again</p>
<mat-list>
  @for (error of validationErrors; track error) {
    <mat-list-item>
      <span class="error">{{ error }}</span>
    </mat-list-item>
  }
</mat-list>
<button mat-raised-button (click)="onClose()">Dismiss</button>